/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportResult } from '../../models/import-result';
import { SchoolInputList } from '../../models/school-input-list';

export interface ApiSchoolSyncPost$Params {
      body: SchoolInputList
}

export function apiSchoolSyncPost(http: HttpClient, rootUrl: string, params: ApiSchoolSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
  const rb = new RequestBuilder(rootUrl, apiSchoolSyncPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportResult>;
    })
  );
}

apiSchoolSyncPost.PATH = '/api/school/sync';
